import React, { useEffect, useState, useContext } from "react";
import { navBarContext, authContext } from "./context/context";
import { useNavigate } from "react-router-dom";
import { getFunctions, httpsCallable } from "firebase/functions"
import {
  query,
  collection,
  db,
  where,
  getDocs,
  addDoc,
  getDoc,
  updateDoc,
  Timestamp,
  writeBatch,
  doc,
} from "../firebase/firebaseApp";
import {
  AdminDashboard,
  FetchButton,
  MatchCard,
  NoMatches,
  Loading,
  PrairiButton,
  TextButton,
  Modal,
} from "@peterfosso/prairi-components";
import { InvestorMatcher, filters } from "../Matching/InvestorMatcher";


const Admin = () => {
  const { navBarHeight } = useContext(navBarContext);
  const { currentUser } = useContext(authContext);

  const [startupsFetched, setStartupsFetched] = useState(false);
  const [investorsFetched, setInvestorsFetched] = useState(false);
  const [matchesFetched, setMatchesFetched] = useState(false);
  let tracker = 0;
  const { uid } = currentUser || {};

  const isAdminUser =
    currentUser && currentUser.uid === "A3Go76mJaLT2GeqHsxlYZRCOWur2";

  let [startups, setStartups] = useState([]);
  let [investors, setInvestors] = useState([]);
  const [matches, setMatches] = useState([]);
  const [matchesData, setMatchesData] = useState([]);
  const [fetchedMatches, setFetchedMatches] = useState([]);
  const [fetchButtonClicked, setFetchButtonClicked] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [approvePopup, setApprovePopup] = useState(false);
  const [rejectPopup, setRejectPopup] = useState(false);

  let navigate = useNavigate();

  const investorMatcher = new InvestorMatcher();

  investorMatcher.addFilter("stage");
  investorMatcher.addFilter("industry");
  investorMatcher.addFilter("amount");
  investorMatcher.addFilter("location");

  useEffect(() => {
    window.scrollTo(0, 0);

  }, []);
  
  const fetchInvestors = async () => {
    //console.log("Fetching investors...");
    const investorsCollection = query(
      collection(db, "users"),
      where("category", "==", "investor"),
      where("formData", "!=", null),
      where("formData.matching.completed", "==", true),
      where("paused", "==", false)
    );
    const snapshot = await getDocs(investorsCollection, { fromCache: false });
    const investorData = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setInvestors(investorData);
    setInvestorsFetched(true);
    console.log("investors fetched");
  };

  const fetchStartups = async () => {
    //console.log("Fetching startups...");
    const startupsCollection = query(
      collection(db, "users"),
      where("category", "==", "startup"),
      where("formData", "!=", null),
      where("formData.matching.completed", "==", true),
      where("paused", "==", false)
    );
    const snapshot = await getDocs(startupsCollection, { fromCache: false });
    const startupData = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setStartups(startupData);
    setStartupsFetched(true);
    console.log("startups fetched");
  };

  const applyFilters = async () => {
    if (!dataFetched) {
      return;
    }
  
    const newMatches = [];
    setMatches([]);
  
    for (const investor of investors) {
      try {
        const filteredStartups = startups.filter(
          (startup) =>
            !fetchedMatches.some(
              (match) =>
                match.investor === investor.id && match.startup === startup.id
            )
        );
        console.log(
          `filtered startups for investor ${investor.id}: ${filteredStartups.map((s) => s.id)}`
        );
  
        const filteredDataIterator = investorMatcher.doFilter(investor, filteredStartups);
  
        for (const startup of filteredDataIterator) { // Iterar sobre el generador
          newMatches.push({
            investor: investor.id,
            startup: startup.id,
          });
        }
        
      } catch (error) {
        // Manejar errores (por ejemplo, cuando no se encuentran coincidencias)
        console.error("No matches found for investor:", investor);
      }
    }
  
    await storePendingMatches(newMatches);
    setMatches(newMatches);
    setFiltersApplied(true);
  };
  

  const fetchMatches = async () => {
    //So we don't repeat matches
    const matchesCollection = collection(db, "matches");
    console.log("Fetching matches...");
    const snapshot = await getDocs(matchesCollection, { fromCache: false });
    const fetchedMatches = snapshot.docs.map((doc) => {
      const matchData = doc.data();
      return {
        id: doc.id,
        ...matchData,
      };
    });
    setFetchedMatches(fetchedMatches);
    setMatchesFetched(true);
    console.log("Fetched existing matches");
  };

  const [dataFetched, setDataFetched] = useState(false);
  const [filtersApplied, setFiltersApplied] = useState(false);

  const fetchData = async () => {
    await Promise.all([fetchStartups(), fetchInvestors(), fetchMatches()]); //add , fetchMatches()
    console.log("promise fetchData");
    // console.log(`investors ${JSON.stringify(investors)}`)
    console.log(`fetched matches: ${JSON.stringify(fetchedMatches)}`);
    setDataFetched(true);
  };

  const handleApplyFiltersClick = async () => {
    await fetchData(); // Wait for data to be fetched
    applyFilters(); // Now you can safely apply filters
    setFetchButtonClicked(true);
    console.log("handleApplyFilters");
  };

  const storePendingMatches = async (matches) => {
    const matchesCollection = collection(db, "pendingMatches");

    // Delete the entire collection
    const batch = writeBatch(db);
    const snapshot = await getDocs(matchesCollection);
    if (!snapshot.empty) {
      snapshot.forEach((doc) => {
        batch.delete(doc.ref);
      });
      await batch.commit();
    }
    // Store the new matches
    for (const match of matches) {
      const dataToStore = {
        investor: match.investor,
        startup: match.startup,
        date: Timestamp.fromDate(new Date()),
      };
      await addDoc(matchesCollection, dataToStore);
    }
  };

  const getMatchesData = async (matches) => {
    const usersCollection = collection(db, "users");
    const data = [];

    for (const match of matches) {
      console.log(`match inside for ${JSON.stringify(match)}`);
      console.log(`match.investor inside for ${match.investor}`);
      const investorDocRef = doc(usersCollection, match.investor);
      const investorSnapshot = await getDoc(investorDocRef);

      const investorData = {
        ...investorSnapshot.data(),
        id: investorSnapshot.id,
      };

      const startupDocRef = doc(usersCollection, match.startup);
      const startupSnapshot = await getDoc(startupDocRef);

      const startupData = {
        ...startupSnapshot.data(),
        id: startupSnapshot.id,
      };

      const matchData = {
        investor: investorData,
        startup: startupData,
      };
      console.log("match data empty");
      console.log(`match data: ${matchData}`);
      data.push(matchData);
    }

    // Set the matches data after the loop has completed
    console.log(
      `data previous setMatchesData in getMatchesData" ${JSON.stringify(data)}`
    );
    setMatchesData(data);
  };

  //***********important************/
  const removeMatchFromData = (investorId, startupId) => {
    const updatedMatchesData = matchesData.filter(
      (match) =>
        match.investor.id !== investorId || match.startup.id !== startupId
    );
    setMatchesData(updatedMatchesData);
  };


      const sendEmail = async (investor) => {
        const functions = getFunctions();
        const sendEmailFn = httpsCallable(functions, "sendEmail");

        try {
            await sendEmailFn({
                templateId: 25, 
                recipients: [
                  {
                    name: investor.data().contactName,
                    email: investor.data().email,
                  },
                ],

                params: {
                  DOCID: investor.id,
                  EMAIL: investor.data().email,
                },
            });
        } catch (error) {
            console.error("Error sending email", error);
        }
    };

  //notifications management
  const handleEmailNotification = async (investor) => {
    // console.log(JSON.stringify(investor))
    try {
      // check if email is already used
      if (!investor) {
        throw new Error("User data is required.");
      }
      if (!investor.data().emailConsent) {
        console.log("no email consent");
        return; // Do not send email if emailConsent is false
      }
      //Send an email to investor about new match
      await sendEmail(investor)
      const userRef = doc(db, "users", investor.id);

      const lastNotification = new Date().toISOString();
      await updateDoc(userRef, { lastNotification: lastNotification });
      setEmailSent(true);
    } catch (err) {
      //console.log("new match email sent to investor")
    }
  };

  const handleSMSNotification = async (investor) => {
    const messagesCollection = collection(db, "messages");
    //console.log(JSON.stringify(investor.data()))
    if (!investor.data().smsConsent) {
      console.log("no sms consent");
      return; // Do not send SMS if smsConsent is false
    }
    const dataToStore = {
      to: `+${investor.data().phone}`,
      body: `PRAIRI has new Startup matches for you. View them before they expire https://prairi.com/notifications/${investor.id} `,
    };
    await addDoc(messagesCollection, dataToStore);
  };

  const handleReject = async (investorId, startupId) => {
    try {
      const matchesCollection = collection(db, "matches");
      const dataToStore = {
        investor: investorId,
        startup: startupId,
        status: "pending",
        accepted: false,
        date: Timestamp.fromDate(new Date()),
      };
      await addDoc(matchesCollection, dataToStore);
      // console.log(JSON.stringify(matchRef))
      // Document successfully updated
      // console.log("Document updated successfully.");
      removeMatchFromData(investorId, startupId);
      setRejectPopup(false);
      tracker++;
    } catch (error) {
      // Handle the error
      //  console.log("Error updating document:", error);
    }
  };

  const handleApprove = async (investorId, startupId) => {
    try {
      const matchesCollection = collection(db, "matches");
      const dataToStore = {
        investor: investorId,
        startup: startupId,
        status: "pending",
        accepted: true,
        date: Timestamp.fromDate(new Date()),
      };
      await addDoc(matchesCollection, dataToStore);

      removeMatchFromData(investorId, startupId);

      const userRef = doc(db, "users", investorId);
      const userDoc = await getDoc(userRef);
      const startupRef = doc(db, "users", startupId)
      const startupDoc = await (getDoc(startupRef))
      // console.log("userdoc", userDoc.data())
      if (startupDoc.exists()){
        const userPendingMatches = userDoc.data().pendingMatches || [];
        const investorToAdd = investorId;
        if (!userPendingMatches.includes(investorToAdd)){
          const updatedPendingMatches = [...userPendingMatches, investorToAdd]
          await updateDoc(startupRef, {
            pendingMatches: updatedPendingMatches
          })
        }
      }
      if (userDoc.exists()) {
        console.log("enters if userDoc exists condition");

        const userPendingMatches = userDoc.data().pendingMatches || [];
        const startupToAdd = startupId;

        if (!userPendingMatches.includes(startupToAdd)) {
          // Add the startup to the array if it doesn't exist
          const updatedPendingMatches = [...userPendingMatches, startupToAdd];

          await updateDoc(userRef, {
            pendingMatches: updatedPendingMatches,
          });
          //addToSummary(startupId, `Hasn't viewed profile yet`, investorId)
          const currentDate = new Date().toISOString();
          const lastNotificationDate =
            (userDoc.data().lastNotification || "").split("T")[0] ?? "";

          if (lastNotificationDate !== currentDate.split("T")[0]) {
            //console.log(`Last notification date: ${lastNotificationDate}`);
            //console.log(`Current date: ${currentDate.split('T')[0]}`);
            handleEmailNotification(userDoc);
            handleSMSNotification(userDoc);
          }
          setApprovePopup(false);
          //console.log("match added to investor");
        }
      }
      tracker++;
    } catch (error) {
      // console.log(error);
    }
  };

  useEffect(() => {
    if (dataFetched && investorsFetched && startupsFetched) {
      applyFilters(); // Apply filters when data is fetched and investors/startups are updated
    }
  }, [dataFetched, investorsFetched, startupsFetched]);

  useEffect(() => {
    if (filtersApplied) {
      getMatchesData(matches); // Fetch and process matches data when filters are applied
    }
  }, [filtersApplied, matches, fetchedMatches]);

  useEffect(() => {
    if (filtersApplied) {
      fetchData(); // Fetch data when filters are applied
    }
  }, [filtersApplied]);

  useEffect(() => {}, [matches, matchesData, fetchedMatches]);

  if (isAdminUser) {
    return (
      <div
        className="px-4 flex flex-col justify-center"
        style={{ marginTop: navBarHeight + 4 }}
      >
        <div className="">
          <div className="flex flex-col justify-center my-8 lg:w-[90%] items-center">
            <div className="justify-center flex ml-4 mb-2">
              <PrairiButton
                label="See users"
                rounded="soft"
                border="silver"
                bgColor="regular"
                click={() => navigate("/users")}
                size="md"
              />
              <PrairiButton
                label="Generate codes"
                rounded="soft"
                border="silver"
                bgColor="regular"
                click={() => navigate("/codegenerator")}
                size="md"
              />
              <PrairiButton
                label="Stats"
                rounded="soft"
                border="silver"
                bgColor="regular"
                click={() => navigate("/stats")}
                size="md"
              />
               <PrairiButton border="silver" bgColor="regular" label="Near Matches" size="md" rounded="soft" click={()=> navigate("/nearmatches")}/>
            </div>
            <FetchButton click={handleApplyFiltersClick} />
            <br/>
           
          </div>
          {!filtersApplied && dataFetched && <Loading />}
          {filtersApplied && matchesFetched && matchesData.length > 0 && (
            <div className="flex justify-center">
              {matchesData.length > 0 ? (
                <div>
                  {matchesData.map(({ investor, startup }) => {
                    const matchId = `${investor.id}-${startup.id}`;
                    return (
                      <div>
                        <MatchCard // Add a unique key
                          key={matchId}
                          match={{ investor, startup }}
                          reject={() => setRejectPopup(matchId)}
                          approve={() => setApprovePopup(matchId)}
                        />
                        <Modal border="green" open={approvePopup === matchId}>
                          <div className=" m-3">
                            <p>
                              {" "}
                              You're about to{" "}
                              <span className="bold">APPROVE</span> the match
                              between {investor.contactName} with{" "}
                              {startup.formData.company.company}.
                            </p>
                          </div>
                          <div className="flex justify-between items-center  w-[80%]">
                            <PrairiButton
                              bgColor="regular"
                              border="green"
                              size="lg"
                              rounded="full"
                              label="YES, NOTIFY INVESTOR"
                              click={() =>
                                handleApprove(investor.id, startup.id)
                              }
                            />
                            <TextButton
                              label="undo"
                              click={() => setApprovePopup(false)}
                            />
                          </div>
                        </Modal>
                        <Modal border="red" open={rejectPopup === matchId}>
                          <div className=" m-3">
                            <p>
                              {" "}
                              You're about to{" "}
                              <span className="bold">REJECT</span> the match
                              between {investor.contactName} with{" "}
                              {startup.formData.company.company}.
                            </p>
                          </div>
                          <div className="flex justify-between items-center  w-[80%]">
                            <PrairiButton
                              bgColor="regular"
                              border="red"
                              size="lg"
                              rounded="full"
                              label="YES, REJECT"
                              click={() =>
                                handleReject(investor.id, startup.id)
                              }
                            />
                            <TextButton
                              label="undo"
                              click={() => setRejectPopup(false)}
                            />
                          </div>
                        </Modal>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <NoMatches />
              )}
            </div>
          )}
        </div>
      </div>
    );
  } else {
    return <>Access forbidden</>;
  }
};

export default Admin;
